import { useGetAccountSettings } from "@/tanstack-hooks";
import { Check, Copy } from "lucide-react";
import { useState } from "react";

export default function CopyReferralCode() {
  const { data } = useGetAccountSettings();
  const domain =
    import.meta.env.VITE_DEPLOYMENT_ENV === "staging"
      ? "staging.pulse-date.com"
      : "app.pulse-date.com";
  const referralLink = data?.referral_code
    ? `${domain}/?code=${data.referral_code}`
    : null;
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    void (async () => {
      try {
        if (!referralLink) return;
        await navigator.clipboard.writeText(referralLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
      } catch (err) {
        console.error("Failed to copy text:", err);
      }
    })();
  }

  if (!referralLink) {
    return (
      <span className="text-md text-red-800 mr-4">
        Error getting referral code
      </span>
    );
  }

  return (
    <div className="flex flex-row gap-4 items-center">
      <a
        href={`https://${referralLink}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-md font-semibold break-words hover:underline"
      >
        {referralLink}
      </a>
      <button
        onClick={handleCopy}
        className="flex-shrink-0 p-2 rounded-md"
        aria-label="Copy referral link"
      >
        {copied ? <Check className="w-6 h-6" /> : <Copy className="w-6 h-6" />}
      </button>
    </div>
  );
}
